export const UserRole = {
  STAFF: 'STAFF',
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  OPERATIONAL_ADMIN: 'OPERATIONAL_ADMIN',
  APPROVER: 'APPROVER',
  REQUESTER: 'REQUESTER',
} as const

export type UserRole = typeof UserRole[keyof typeof UserRole]
